import Vue from 'vue'

export default {
  /*
   * index() lista los operadores
   */
  // index(params, skipLoading = false) {
  //   return Vue.http.get('entity/operators', {params, skipLoading}).then(response => response.data)
  // },
  index(params, skipLoading = false) {
    return Vue.http.get('mobile_app/v1/entity/operators/list', {params, skipLoading}).then(response => response.data)
  },
  /**
   * show() obtiene la informacion de un operador
   */
  show(id, params) {
    return Vue.http.get(`entity/operators/${id}`, {params}).then(response => response.data.data)
  },
  /**
   * create() crea un operador
   * */
  create(data) {
    const sendData = data instanceof FormData ? data : {data}

    return Vue.http.post('entity/operators', sendData).then(response => response.data.data)
  },
  /**
   * update() actualiza un operador
   * */
  update(id, data) {
    const sendData = data instanceof FormData ? data : {data}

    return Vue.http.put(`entity/operators/${id}`, sendData).then(response => response.data.data)
  },
  /**
   * delete() borra un operador
   * */
  delete(id) {
    return Vue.http.delete(`entity/operators/${id}`).catch(
      () => Promise.reject(Vue.i18n.t('general.error'))
    )
  }
}
